import { render, staticRenderFns } from "./service-locations-sms-email-card.vue?vue&type=template&id=f05ad246&scoped=true&"
import script from "./service-locations-sms-email-card.vue?vue&type=script&lang=js&"
export * from "./service-locations-sms-email-card.vue?vue&type=script&lang=js&"
import style0 from "./service-locations-sms-email-card.vue?vue&type=style&index=0&id=f05ad246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05ad246",
  null
  
)

export default component.exports